import { render, staticRenderFns } from "./indx.vue?vue&type=template&id=c6c3b7ec&scoped=true"
import script from "./indx.vue?vue&type=script&lang=js"
export * from "./indx.vue?vue&type=script&lang=js"
import style0 from "./indx.vue?vue&type=style&index=0&id=c6c3b7ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c3b7ec",
  null
  
)

export default component.exports